/**
 * InviteCodeInput
 *
 * Reusable invite code input component
 *
 * Features:
 * - Formatted input (uppercase, alphanumeric)
 * - Client-side validation
 * - Error display
 * - Loading state
 *
 * Used in:
 * - InviteCodeStep (registration wizard)
 * - RequestInviteForm (invite request page)
 */

interface InviteCodeInputProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  className?: string;
}

export function InviteCodeInput({
  value,
  onChange,
  onBlur,
  error,
  disabled,
  className = '',
}: InviteCodeInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Auto-uppercase and allow only alphanumeric
    const formatted = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    onChange(formatted);
  };

  return (
    <div className={className}>
      <label htmlFor="invite-code" className="block text-sm font-medium text-neutral-700 mb-1">
        Invite Code
      </label>
      <input
        id="invite-code"
        type="text"
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={disabled}
        maxLength={12}
        placeholder="ABC123XYZ"
        className={`
          input
          ${error ? 'border-red-500 focus:ring-red-500' : ''}
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        `}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}
